import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Region } from '../../../models/region';
import { Product_Type } from '../../../models/product_Type';
import { NetHoldingsService } from '../../../services/net-holdings.service';
import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { PDAUserService } from '../../../services/pda-user.service';
import { ReportableService } from '../../../services/reportable.service';
import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { RegionService } from '../../../services/region.service';
import { ProductTypeService } from '../../../services/product-type.service';
import { PDAUser } from '../../../models/pda_User';
import { CheckUserType } from '../../../models/checkUserType';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
  selector: 'app-net-holdings',
  templateUrl: './net-holdings.component.html',
  styleUrls: ['./net-holdings.component.css']
})
export class NetHoldingsComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;

  customerTypes: Customer_Type[];
  users: PDAUser[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  regions: Region[];
  regionList: Region[];

  productTypes: Product_Type[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    region_Id: 0,
    product_Type_Id: 0,
    quick_Search: ''
  };
  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, pdaUserService: PDAUserService,
    public netHoldingsService: NetHoldingsService, public reportableService: ReportableService,
    customerTypeService: CustomerTypeService, regionService: RegionService, productTypeService: ProductTypeService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "company";

    productTypeService.getAll().then((data) => {
      this.productTypes = data;
    });

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }
      
      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = [];

        /*if (this.role.isStandard) {
          this.locations = this.locationList.filter(c => {
            return c.company_Id == this.filter.company_Id;
          });
        }*/

      });

      regionService.getAll(this.filter.company_Id).then((data) => {
        this.regionList = data;
        this.regions = this.regionList;

        if (this.role.isStandard) {
          this.regions = this.regionList.filter(c => {
            return c.company_Id == this.filter.company_Id;
          });
        }
      });

      //this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;

    pdaUserService.getAll().then((data) => {
      this.users = data;
    });
  }

  ngOnInit() {
    //this.loadTable(this.page);
    this.init = true;
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { 
      value = null;
      this.locations = [];
      this.regions = [];
      return; 
    }
    
    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });

    this.regions = this.regionList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);
    console.log(value)
    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    console.log("Attempting to Load Table");
    this.netHoldingsService.getResults(this.page, this.filter.company_Id, this.filter.location_Id,
      this.filter.region_Id, this.filter.product_Type_Id, this.role.isStandard, 
      this.filter.customer_Type_Id, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        console.log(this.page);
        console.log(this.rows);
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.netHoldingsService.getExcel(this.page, this.filter.company_Id, this.filter.location_Id,
      this.filter.region_Id, this.filter.product_Type_Id, this.role.isStandard, 
      this.filter.customer_Type_Id).then((data) => {
        importedSaveAs(data, 'Net Holdings.xlsx');
      });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
